import type { SearchResultContact } from "@/features/meetings/services/contacts.api"
import { pickPeerEntry } from "./peer-directory"

/**
 * Decide a DM peer's email/organisation from an id lookup, falling back to
 * the old name search only when the lookup has nothing.
 *
 * `lookupResult` is the directory row for the peer's OWN id (or `null` when
 * `/contacts/lookup` failed, e.g. 404 on a server without the route yet, or
 * simply had no row for this id). It always wins when present: it was found
 * by the exact id, so there is no ambiguity to weigh against anything else.
 * `fallbackLists` is only consulted when `lookupResult` is `null`. Today the
 * caller passes a single `global`-scope search result (that scope already
 * contains every narrower one), wrapped in a list so this stays the same
 * shape `pickPeerEntry` always took, back when the fallback searched each
 * scope separately before `/contacts/lookup` existed.
 */
export function resolvePeerEntry(
  lookupResult: SearchResultContact | null,
  fallbackLists: Array<SearchResultContact[] | null>,
  peerId: string,
): { email?: string; orgName?: string } | null {
  if (lookupResult) return { email: lookupResult.email, orgName: lookupResult.contactOrgName }
  return pickPeerEntry(fallbackLists, peerId)
}
